import { Tabs, TabList, Tab, TabsProps } from "@chakra-ui/react";
import { ReactNode } from "react";

type Props<V extends string | number | symbol> = Omit<
  TabsProps,
  "index" | "onChange" | "children"
> & {
  children?: ReactNode;
  getItemLabel?: (item: V | null) => ReactNode;
  items: ReadonlyArray<V | null>;
  itemLabels?: Partial<Record<V, ReactNode>>;
  onChange: (selected: V | null) => void;
  selected: V | null | undefined;
};

export default function TabListArray<V extends string | number | symbol>({
  children,
  items,
  itemLabels,
  getItemLabel = (item) => itemLabels?.[item] || String(item),
  onChange,
  selected,
  ...rest
}: Props<V>) {
  return (
    <Tabs
      variant="solid-rounded"
      colorScheme="pinkButton"
      size="sm"
      index={
        typeof selected === "undefined" ? undefined : items.indexOf(selected)
      }
      onChange={(index) => onChange(items[index])}
      {...rest}
    >
      <TabList flexWrap="wrap" gap={1}>
        {items.map((opt) => (
          <Tab key={String(opt)}>{getItemLabel(opt)}</Tab>
        ))}
      </TabList>
      {children}
    </Tabs>
  );
}
